// Developed by Aptus Engineering, Inc. <https://aptusai.com>
// See LICENSE.md file in project root directory


export default async (ms) => {
    await new Promise(resolve => setTimeout(resolve, ms));
}